module.exports = __webpack_public_path__ + "img/public_logo.48ad4f63.png";